// Libraries
var React = require('react');
var $ = require('jquery');

// Components
var TwitterEmbed = require("./TwitterEmbed");
var LoadMore = require('../../../common/LoadMore/LoadMore');

// Assets
var spinner = require('../../../common/images/Rolling.svg');

// Styles
require('./SocialTabModule.scss');

class SocialTabModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			initialDataPaged: [],
			newData: [],
			isLoading: true,
			isMore: false
		};

		this.initialDataAll = [];
		this.pageSize = 10;
		this.currentPage = 0;
		this.pages = 0;
	}

	componentDidMount() {
		// delay the load of the realtime library until it's reached the browser 
		// to avoid server side rendering errors
		this.Realtime = require('../../../common/Realtime/Realtime');

		$.ajax({
			method: "GET",
			url: this.props.data.endpoints[0].url
		})
		.done((data) => {

			this.initialDataAll = data.slice();
			this.pages = Math.ceil(data.length / this.pageSize);

			let initialDataPaged = data.slice(0, this.pageSize);

			this.setState({
				initialDataPaged: initialDataPaged,
				isLoading: false,
				isMore: (initialDataPaged.length < this.initialDataAll.length)
			});
		})
		.fail(() => {
			this.setState({ isLoading: false });
		});

		this.attachChannels();
	}

	handleLoadMore = () => {
		this.currentPage++;

		let initialDataPaged = this.initialDataAll.slice(0, (this.currentPage + 1) * this.pageSize);

		this.setState({
			initialDataPaged: initialDataPaged,
			pages: Math.ceil(this.initialDataAll.length),
			isMore: initialDataPaged.length !== this.initialDataAll.length
		});
	};

	updateItem = (item) => {
		let realtimeData = this.state.newData.slice();		
		realtimeData.unshift(...item);

		this.setState({
			newData: realtimeData
		});
	};

	attachChannels() {
		let itemChannel = this.props.data.endpoints.find(x => x.name === "social").channelId;

		this.Realtime.subscribe(itemChannel, this.props.data.realtimeKey, (message) => {
			if (message.data.length > 0) {

				message.data.forEach((item, index) => {
					item.EntityId = item.Id.split('-').reverse()[0];
				});
				
				this.updateItem(message.data);
			}
		});
	}

	render() {
		return (
			<div className="SocialTab">
				{!this.state.isLoading && this.state.initialDataPaged.length > 0 &&
					<div className="SocialTab__title">
						<h2>Social Media</h2>
						<p>Find the latest Twitter trends.</p>
					</div>
				}

				{/* The new Social from the WebSocket connect will be placed here. */}
				<div className="SocialTab__wrapper">
					{this.state.newData.length > 0 &&
						this.state.newData.map((item, index) =>
							<TwitterEmbed data={item} key={item.EntityId} />
					)}
				</div>

				{/* The previously broadcast Social, loaded on page load, will appear here, paginated. */}
				<div className="SocialTab__wrapper">
					{this.state.initialDataPaged.length > 0 &&
						this.state.initialDataPaged.map((item, index) =>
							<TwitterEmbed data={item} key={item.EntityId} />
					)}
				</div>

				{this.state.isMore &&
					<LoadMore handle={this.handleLoadMore} caption="Show more" context="social content"/>
				}

				{this.state.isLoading &&
					<img src={spinner} className="spinner" alt="Loading..." />
				}

				{!this.state.isLoading && this.state.initialDataPaged.length === 0 &&
					<p>No Social data is available</p>
				}
			</div>
		)
	}
}

module.exports = SocialTabModule;



// WEBPACK FOOTER //
// ./src/components/MDC/SocialTab/SocialTabModule.js